var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10ZM11 4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4V5C7.34315 5 6 6.34315 6 8C6 9.65685 7.34315 11 9 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H7.5C6.94772 13 6.5 13.4477 6.5 14C6.5 14.5523 6.94772 15 7.5 15H9V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V15C12.6569 15 14 13.6569 14 12C14 10.3431 12.6569 9 11 9H9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7H12.5C13.0523 7 13.5 6.55228 13.5 6C13.5 5.44772 13.0523 5 12.5 5H11V4Z",
    fill: "#2F4DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.63abf9cbdbc6e68e0ab2d1ae8744b069.svg";
export { ForwardRef as ReactComponent };